import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { Tabs, TabsList, TabsTrigger } from '@onward-delivery/design';
import { useClientUser } from '@/hooks';
import { PrimaryHeaderLabel } from './blocks';
import { PRIMARY_TABS } from './constants';
import SkuHistoryModal from './modals/SkuHistoryModal';
import DeliveryInventory from './DeliveryInventory';
import ForwardStocking from './ForwardStocking';

const InventoryManagement = ({ state, loading, callbacks }) => {
    const { primaryTab } = state;
    const { accountType } = useClientUser();
    // Only shippers and carriers hold forward stocked inventory. For everyone
    // else there is nothing to switch between, so the tab bar is not rendered.
    const hasForwardStocking = accountType === 'carrier' || accountType === 'shipper';
    const isForwardStocking = hasForwardStocking && primaryTab === PRIMARY_TABS.FORWARD_STOCKING;

    return (
        <>
            <Grid
                container
                item
                direction="column"
                css={css`
                    padding: 30px 40px 0;
                    background-color: white;
                `}
            >
                <PrimaryHeaderLabel>Inventory Dashboard</PrimaryHeaderLabel>
                {hasForwardStocking ? (
                    <div className="onward-design">
                        <div className="mt-4">
                            <Tabs value={primaryTab} onValueChange={callbacks.setPrimaryTab}>
                                <TabsList variant="underline">
                                    <TabsTrigger value={PRIMARY_TABS.FORWARD_STOCKING}>Forward Stocking</TabsTrigger>
                                    <TabsTrigger value={PRIMARY_TABS.DELIVERY}>Delivery</TabsTrigger>
                                </TabsList>
                            </Tabs>
                        </div>
                    </div>
                ) : null}
            </Grid>

            {isForwardStocking ? (
                <Grid
                    item
                    css={css`
                        overflow: hidden;
                        flex-grow: 1;
                        padding: 24px 40px 0;
                    `}
                >
                    <ForwardStocking />
                </Grid>
            ) : (
                <DeliveryInventory state={state} loading={loading} callbacks={callbacks} />
            )}

            <SkuHistoryModal state={state} callbacks={callbacks} />
        </>
    );
};

export default InventoryManagement;
